import { FETCH_ASSIGNEES_ASYNC } from 'containers/ResolutionCenter/Report/constants'

import {
  ACTIONS_LIST,
  CHANGE_INCIDENT_STATE_REQUEST_ASYNC,
  RESET_REMEDIATION_CONFIRMATION,
  TOGGLE_REMEDIATION_ACTION,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    error: null,
    page: 1,
    remediationActions: {
      // [ACTIONS_LIST.RESET_PASSWORD]: true,
      // [ACTIONS_LIST.DISABLE_SIGNIN]: true,
      [ACTIONS_LIST.SIGN_OUT]: true,
    },
    showRemediationConfirmation: false,
    assignees: {
      loader: false,
      error: null,
      data: [],
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.INITIATE: {
        return {
          ...state,
          error: null,
          loader: true,
        }
      }
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.SUCCESS: {
        return {
          ...state,
          error: null,
          loader: false,
          showRemediationConfirmation: state.remediationActions,
        }
      }
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
        }
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          showRemediationConfirmation: false,
        }
      case RESET_REMEDIATION_CONFIRMATION:
        return {
          ...state,
          showRemediationConfirmation: false,
        }
      case TOGGLE_REMEDIATION_ACTION:
        return {
          ...state,
          remediationActions: {
            ...state.remediationActions,
            [action.payload.actionType]: !state.remediationActions[action.payload.actionType],
          },
        }
      case FETCH_ASSIGNEES_ASYNC.INITIATE: {
        return {
          ...state,
          assignees: { ...state.assignees, loader: true },
        }
      }
      case FETCH_ASSIGNEES_ASYNC.SUCCESS: {
        return {
          ...state,
          assignees: {
            loader: false,
            error: null,
            data: action.payload.data,
          },
        }
      }
      case FETCH_ASSIGNEES_ASYNC.ERROR:
        return {
          ...state,
          assignees: {
            loader: false,
            data: [],
            error: action.error.response?.message,
          },
        }
      default:
        return state
    }
  }
}
